import { Button } from '@sunwebgroup/uds-ui/button'
import { RichText } from '@sunwebgroup/uds-ui/rich-text'
import { Window } from '@sunwebgroup/uds-ui/window'
import { useState } from 'react'
import { useIntl } from '@/intl'
import styles from '@/scopes/checkout/components/CheckoutNextStep/OptionalAncillariesWindow.module.css'
import { confirmActionWindowIsOpenSelector } from '@/scopes/checkout/components/PersonalDetailsForm/selectors'
import { useBookingDraftQuery } from '@/scopes/checkout/domain/hooks'
import { hasAnyExternalFlight } from '@/scopes/checkout/domain/policies/transports'
import { useCheckoutPersonalDetailsActions } from '@/scopes/checkout/infrastructure/dependencies/dependencies'
import { useParticipantsFormStepStore } from '@/scopes/checkout/infrastructure/store/useParticipantsFormStepStore'
import { useOptimizelyFlagContext } from '@/scopes/common/infrastructure/ab-testing/optimizely/useOptimizely'

export function ConfirmActionWindow() {
  const intl = useIntl()
  const isOpen = useParticipantsFormStepStore(confirmActionWindowIsOpenSelector)
  const actions = useCheckoutPersonalDetailsActions()
  const [isNavigating, setIsNavigating] = useState(false)
  const { data: bookingDraftData } = useBookingDraftQuery()
  const { showMandatoryPaymentPage } = useOptimizelyFlagContext()

  const handleConfirm = () => {
    setIsNavigating(true)

    if (showMandatoryPaymentPage && hasAnyExternalFlight(bookingDraftData?.transportInfo)) {
      actions.redirectToMandatoryPaymentStepSZabTest()
    }
    else {
      actions.redirectToNextStep()
    }
  }

  return (
    <Window.Root open={isOpen}>
      <Window
        className={styles.window}
        title={intl.formatMessage({ id: 'checkout_steps_confirm_action_window_title' })}
        closeLabel={intl.formatMessage({ id: 'close' })}
        onCloseClick={actions.closeConfirmActionWindow}
        hasTitleBar
      >
        <RichText innerHTML={intl.formatMessage({ id: 'checkout_steps_confirm_action_window_description' })} />

        <div className={styles.actions}>
          <Button
            variant="primary"
            onClick={handleConfirm}
            disabled={isNavigating}
            isLoading={isNavigating}
            data-qa="checkout-next-step-confirm-button"
          >
            {intl.formatMessage({ id: 'checkout_steps_confirm_action_window_confirm_button_text' })}
          </Button>
        </div>
      </Window>
    </Window.Root>
  )
}
